import './App.css';
import {MyButton, Link} from "./AppUi"
import React from 'react';
import FrmKontakt from "./components/FrmKontakt";

class App extends React.Component {


  nakonfig = "";
  formdata ={};
  alertok = "";
  alerterr = "";
  nadpis = "";
  mobil = "";
  mail = "";
  meno = "";
  dokonc = "";

  naplnTextyPodlaJazyka() {

      this.nakonfig = "PRIHLÁSIŤ SA";
      this.konf = "Výchova talentov";

      this.formdata.alertok = "Správa bola odoslaná. Budeme Vás kontaktovať do 72 hodín.";
      this.formdata.alerterr = "Správu žiaľ nebolo možné odoslať. Kontaktujte nás prosím emailom alebo telefonicky.";
      this.formdata.nadpis = ""; // "Vďaka projektu Úradu práce „Nestrať prácu - vzdelávaj sa” viete získať zľavu až -100% na toto školenie. Mimoriadne platí aj pre zamestnancov, SZČO a aj pre mamičky na rodičovskej dovolenke. Tento projekt je časovo aj finančne limitovaný. Nestrácajte čas, stačí vyplniť žiadosť s ktorou Vám radi pomôžeme. Mame Vám zavolať alebo napísať email ? Ďakujeme";
      this.formdata.mobil = "cez mobil";
      this.formdata.mail = "cez email";
      this.formdata.meno = "Meno";
      this.formdata.dokonc = "Dokončiť";

  }

  constructor(props) {
    super(props);
    this.naplnTextyPodlaJazyka();
  }

  render() { const tlacitkaAkcie = [
    { 
      nazov: this.nakonfig,
      poziadavka: this.konf,
    }
  ];

  const vratForm = (poziadavka) => {
    // console.log ("[LCK]: kliknutie na tlacitko [start]");

    const hdnPoziadavka = document.getElementById('hdnPoziadavka');
    hdnPoziadavka.value = poziadavka;
    
    const titulok = document.getElementById('lit-frm-mod-tit');
    // titulok.innerHTML = poziadavka;
    
    
    console.log ("[LCK]: kliknutie na tlacitko [end]");
  }

   return (
    <div className="lit-cmp-kontakt-wrapper">
      {tlacitkaAkcie.map( 
        tlacitko => <div>
                        <Link>
                            <button class="vychova-btn" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => vratForm(tlacitko.poziadavka)}>{tlacitko.nazov}</button>
                        </Link>
                    </div>
      )
      }
      <FrmKontakt formdata={this.formdata} ></FrmKontakt>
    </div>
  );
    }

}

export default App;
